export default "__VITE_ASSET__TVRRDooy__"